import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const FilledSuccessIcon = ({ fill = 'green', size = 'large' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox={'0 0 16 16'}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm3.787 6.333a.727.727 0 0 0-1.029-1.029l-3.85 3.85-1.667-1.668a.727.727 0 0 0-1.028 1.029l2.181 2.181a.727.727 0 0 0 1.029 0l4.364-4.363Z"
                className={fillStyles}
            />
        </svg>
    );
};
